export enum HeadcountSettingsWorkflowTemplateTypeEnum {
  ManagerMail = 'ManagerMail'
}
